import React from 'react';

function Lesotho(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124071)">
        <mask
          id="mask0_800_124071"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124071)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 16H36V24H0V16Z"
            fill="#55BA07"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 8H36V16H0V8Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V8H0V0Z"
            fill="#3D58DB"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.1562 8.24029C16.5682 8.38062 16.2577 8.74184 16.2577 9.38097C16.2577 10.1114 16.6612 10.797 17.1562 11.1505V8.24029ZM18.5625 11.1309C19.0438 10.7725 19.4307 10.0997 19.4307 9.38284C19.4307 8.76211 19.125 8.40252 18.5625 8.25329V11.1309ZM18.4912 7.72767C19.4243 7.9045 20.1021 8.46364 20.1021 9.377C20.1021 10.0356 19.7497 10.8363 19.2032 11.3858L21.9411 13.7728L22.6165 13.5751L23.625 14.9348C23.625 14.9348 21.0758 16 17.9251 16C14.7744 16 12.375 14.9348 12.375 14.9348L13.2336 13.7728L13.9269 13.9748L16.4671 11.4271C15.8968 10.8771 15.5262 10.0524 15.5262 9.377C15.5262 8.43158 16.2524 7.86568 17.2362 7.71046C17.3538 7.48628 17.5887 7.33334 17.8594 7.33334C18.1369 7.33334 18.3769 7.49415 18.4912 7.72767ZM13.5018 14.2964L13.2166 14.6488H13.7718L13.5018 14.2964ZM13.827 14.7879L13.3367 14.8757L13.827 15.0275V14.7879ZM14.0772 14.2803L14.3279 14.8006L14.9506 14.6496L14.8271 14.4404L14.0772 14.2803ZM15.4314 15.3179L14.5169 15.1577L14.4123 15.0014L15.1019 14.868L15.4314 15.3179ZM15.4847 14.5733L15.769 15.0279L16.3939 14.8588L16.22 14.655L15.4847 14.5733ZM15.9972 15.4086L15.8853 15.2206L16.5769 15.0565L16.9749 15.4888L15.9972 15.4086ZM17.2886 15.0965L18.1799 14.887L18.0703 14.7071H16.9135L17.2886 15.0965ZM17.6082 15.497L17.4666 15.3024L18.3227 15.0532L18.7768 15.497H17.6082ZM18.6913 14.7209L18.9651 15.019L19.7064 14.7906L19.6135 14.6349L18.6913 14.7209ZM20.3002 15.3406L19.3036 15.4391L19.157 15.2191L19.9107 14.9991L20.3002 15.3406ZM20.2371 14.577L20.5162 14.882L21.1853 14.577L20.9997 14.4853L20.2371 14.577ZM20.8159 15.2586L20.6948 15.0936L21.3315 14.754L21.6551 15.0936L20.8159 15.2586ZM21.4479 14.3097L21.8522 14.6526L22.2455 14.3097L22.1211 14.1702L21.4479 14.3097ZM22.0888 14.7704L22.4185 14.4805L22.6552 14.7704L22.0888 14.9323V14.7704Z"
            fill="#1D1D1D"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124071">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Lesotho;
